import { gql } from '@apollo/client';
import { Dispatch } from '../components/architecture/frontend/index'
import { merge } from 'rxjs'
import { map, filter, withLatestFrom } from 'rxjs/operators'

import _ from 'lodash'

import bufferObject from './bufferObject'

bufferObject('ingredients')

const fragment = `
  fragment IngredientData on Ingredient {
    id
    name   
    code
    sampleType {
      id
      name
      code
    }
    proteinClaimable
    fiberClaimable
    moistureThreshold
    fiberThreshold
    proteinThreshold
    isActive
  }
  `


const GET_INGREDIENTS = gql`
  query ingredients {
    ingredients {
      ...IngredientData
    }
  }
  ${fragment},
`;

const MUTATE_UPSERT_INGREDIENTS = gql`
  mutation upsertIngredients(
      $ingredients: [IngredientInput]
    ){
      upsertIngredients(
        ingredients: $ingredients
      ) {
        ...IngredientData
      }
    }
    ${fragment}
`;

Dispatch.getState('user.email')
  .pipe(
  )
  .subscribe(e => {
    if (_.isNil(e)) {
      Dispatch.nextAction('__.buffer.setRaw.ingredients', null)
    }
    else {
      Dispatch.nextAction('__.buffer.setLoading.ingredients')
      Dispatch.nextAction('Request.ingredients', { type: 'query', query: GET_INGREDIENTS, variables: { }, poll: process.env.REACT_APP_POLL_INTERVAL,  retry: process.env.REACT_APP_RETRY_INTERVAL })
    }
  })

  merge(Dispatch.getAction('Response.ingredients'), Dispatch.getAction('Response.ingredients.save'))
  .pipe(
    filter(e => _.isNil(e.errors)),
    map(e => e.data.ingredients ?? e.data.upsertIngredients)
  )
  .subscribe(e => Dispatch.nextAction('__.buffer.setRawAndClearBuffer.ingredients', e))

Dispatch.getAction('ingredients.save')
    .pipe(
      withLatestFrom(Dispatch.getState('ingredients.bufferData')),
      map(([details, buffer]) => buffer.map(data => ({
        id: data.id, 
        code: data.code, 
        name: data.name, 
        shipmentType: data.shipmentType?.id,
        proteinClaimable: data.proteinClaimable,
        fiberClaimable: data.fiberClaimable,
        proteinThreshold: data.proteinThreshold,
        fiberThreshold: data.fiberThreshold,
        moistureThreshold: data.moistureThreshold
      })))
    )
    .subscribe(e => Dispatch.nextAction('Request.ingredients.save', { type: 'mutation', query: MUTATE_UPSERT_INGREDIENTS, variables: { ingredients: e } }))